import React from "react";
import PropTypes from 'prop-types';
import "./buttonSkeleton.scss";
function URButtonSkeleton(props: any) {
  let {className } = props;
  return (
    <>
      <div className={className}></div>
    </>

  );
}

export {
  URButtonSkeleton
};

URButtonSkeleton.propTypes = {
  className: PropTypes.any
};